import { render, staticRenderFns } from "./CollectionFilterControlTypeCurrency.vue?vue&type=template&id=c01b030a"
import script from "./CollectionFilterControlTypeCurrency.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeCurrency.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports